import React, { useState, useEffect, useCallback } from 'react';
import DeleteIcon from './assets/images/delete-icon.svg';
import UndoIcon from './assets/images/undo-icon.svg';

function SilinmislerListesi() {
    const [silinmisler, setSilinmisler] = useState([]);
    const [yukleniyor, setYukleniyor] = useState(true);
    const [seciliIds, setSeciliIds] = useState([]);

    const fetchSilinmisler = useCallback(async () => {
        setYukleniyor(true);
        try {
            const response = await fetch('/api/silinmis-siparisler', {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            if (!response.ok) throw new Error('Veri alınamadı.');
            const data = await response.json();
            setSilinmisler(data);
        } catch (error) {
            alert(`Hata: ${error.message}`);
        } finally {
            setYukleniyor(false);
        }
    }, []);

    useEffect(() => { fetchSilinmisler(); }, [fetchSilinmisler]);

    const handleGeriYukle = async (siparisId, siparisNo) => {
        if (!window.confirm(`#${siparisNo} numaralı sipariş geri yüklenecek. Onaylıyor musunuz?`)) return;
        try {
            const res = await fetch(`/api/siparisler/${siparisId}/geri-yukle`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.hata || 'Hata oluştu.');
            alert(data.mesaj);
            fetchSilinmisler();
        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    const handleKaliciSil = async (siparisId, siparisNo) => {
        if (!window.confirm(`#${siparisNo} numaralı sipariş KALICI olarak silinecektir. Bu işlem geri alınamaz. Emin misiniz?`)) return;
        try {
            const res = await fetch(`/api/siparisler/${siparisId}/kalici-sil`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.hata || 'Hata oluştu.');
            alert(data.mesaj);
            setSeciliIds(prev => prev.filter(id => id !== siparisId));
            fetchSilinmisler();
        } catch (error) {
            alert(`Hata: ${error.message}`);
        }
    };

    const toggleSecim = (id) => {
        setSeciliIds(prev =>
            prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
    };

    const tumunuSec = () => {
        if (seciliIds.length === silinmisler.length) {
            setSeciliIds([]);
        } else {
            setSeciliIds(silinmisler.map(s => s.id));
        }
    };

    const handleTopluKaliciSil = async () => {
        if (seciliIds.length === 0) return alert('Lütfen en az bir sipariş seçin.');
        if (!window.confirm(`Seçili ${seciliIds.length} sipariş KALICI olarak silinecektir. Bu işlem geri alınamaz!`)) return;
        let basarili = 0;
        for (const id of seciliIds) {
            try {
                const res = await fetch(`/api/siparisler/${id}/kalici-sil`, {
                    method: 'DELETE',
                    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                });
                if (res.ok) basarili++;
            } catch {}
        }
        alert(`${basarili} sipariş kalıcı olarak silindi.`);
        setSeciliIds([]);
        fetchSilinmisler();
    };

    const handleTopluGeriYukle = async () => {
        if (seciliIds.length === 0) return alert('Lütfen en az bir sipariş seçin.');
        if (!window.confirm(`Seçili ${seciliIds.length} sipariş geri yüklenecek. Onaylıyor musunuz?`)) return;
        let basarili = 0;
        for (const id of seciliIds) {
            try {
                const res = await fetch(`/api/siparisler/${id}/geri-yukle`, {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
                });
                if (res.ok) basarili++;
            } catch {}
        }
        alert(`${basarili} sipariş geri yüklendi.`);
        setSeciliIds([]);
        fetchSilinmisler();
    };

    const kalanGunRengi = (gun) => {
        if (gun <= 3) return '#dc3545';
        if (gun <= 10) return '#fd7e14';
        return '#6c757d';
    };

    return (
        <div style={{ fontFamily: 'Poppins, sans-serif', padding: '0' }}>
            {/* Başlık */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '20px',
                flexWrap: 'wrap',
                gap: '10px'
            }}>
                <div>
                    <p style={{ margin: '4px 0 0', fontSize: '13px', color: '#888' }}>
                        Çöp Kutusundaki siparişler 30 gün boyunca burada tutulur, ardından otomatik olarak kalıcı silinir.
                    </p>
                </div>
                {seciliIds.length > 0 && (
                    <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                            onClick={handleTopluGeriYukle}
                            style={{
                                background: '#28a745', color: 'white', border: 'none',
                                borderRadius: '6px', padding: '8px 16px', fontSize: '13px',
                                cursor: 'pointer', fontWeight: 600
                            }}
                        >
                            ↩ Geri Yükle ({seciliIds.length})
                        </button>
                        <button
                            onClick={handleTopluKaliciSil}
                            style={{
                                background: '#dc3545', color: 'white', border: 'none',
                                borderRadius: '6px', padding: '8px 16px', fontSize: '13px',
                                cursor: 'pointer', fontWeight: 600
                            }}
                        >
                            Kalıcı Sil ({seciliIds.length})
                        </button>
                    </div>
                )}
            </div>

            {yukleniyor ? (
                <div style={{ textAlign: 'center', padding: '60px', color: '#888', fontSize: '15px' }}>
                    Yükleniyor...
                </div>
            ) : silinmisler.length === 0 ? (
                <div style={{
                    textAlign: 'center', padding: '80px 20px',
                    background: 'white', borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
                }}>
                    <div style={{ fontSize: '48px', marginBottom: '12px' }}>🗑️</div>
                    <div style={{ fontSize: '18px', fontWeight: 600, color: '#555' }}>Çöp kutusu boş</div>
                    <div style={{ fontSize: '13px', color: '#aaa', marginTop: '6px' }}>
                        Silinen siparişler burada görünecek.
                    </div>
                </div>
            ) : (
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #e9ecef' }}>
                                <th style={{ padding: '12px 14px', textAlign: 'left', width: '40px' }}>
                                    <input
                                        type="checkbox"
                                        checked={seciliIds.length === silinmisler.length && silinmisler.length > 0}
                                        onChange={tumunuSec}
                                    />
                                </th>
                                <th style={{ padding: '12px 14px', textAlign: 'left', color: '#495057', fontWeight: 600 }}>Sıra</th>
                                <th style={{ padding: '12px 14px', textAlign: 'left', color: '#495057', fontWeight: 600 }}>Telefon</th>
                                <th style={{ padding: '12px 14px', textAlign: 'left', color: '#495057', fontWeight: 600 }}>Ad Soyad</th>
                                <th style={{ padding: '12px 14px', textAlign: 'left', color: '#495057', fontWeight: 600 }}>Adres</th>
                                <th style={{ padding: '12px 14px', textAlign: 'left', color: '#495057', fontWeight: 600 }}>İl</th>
                                <th style={{ padding: '12px 14px', textAlign: 'left', color: '#495057', fontWeight: 600 }}>İlçe</th>
                                <th style={{ padding: '12px 14px', textAlign: 'left', color: '#495057', fontWeight: 600 }}>Toplam Tutar</th>
                                <th style={{ padding: '12px 14px', textAlign: 'left', color: '#495057', fontWeight: 600 }}>Kalan Süre</th>
                                <th style={{ padding: '12px 14px', textAlign: 'center', color: '#495057', fontWeight: 600 }}>İşlem</th>
                            </tr>
                        </thead>
                        <tbody>
                            {silinmisler.map((siparis, idx) => (
                                <tr
                                    key={siparis.id}
                                    style={{
                                        borderBottom: '1px solid #f0f0f0',
                                        background: seciliIds.includes(siparis.id) ? '#fff3cd' : (idx % 2 === 0 ? '#fff' : '#fafafa'),
                                        transition: 'background 0.15s'
                                    }}
                                >
                                    <td style={{ padding: '12px 14px' }}>
                                        <input
                                            type="checkbox"
                                            checked={seciliIds.includes(siparis.id)}
                                            onChange={() => toggleSecim(siparis.id)}
                                        />
                                    </td>
                                    <td style={{ padding: '12px 14px', color: '#555' }}>
                                        {idx + 1}
                                    </td>
                                    <td style={{ padding: '12px 14px', fontSize: '12px', color: '#555' }}>
                                        {siparis.musteri_telefon || '—'}
                                    </td>
                                    <td style={{ padding: '12px 14px', color: '#555' }}>
                                        {siparis.musteri_adi}
                                    </td>
                                    <td style={{ padding: '12px 14px', fontSize: '12px', color: '#555', maxWidth: '180px' }}>
                                        {siparis.musteri_adres || '—'}
                                    </td>
                                    <td style={{ padding: '12px 14px', fontSize: '12px', color: '#555' }}>
                                        {siparis.musteri_il || '—'}
                                    </td>
                                    <td style={{ padding: '12px 14px', fontSize: '12px', color: '#555' }}>
                                        {siparis.musteri_ilce || '—'}
                                    </td>
                                    <td style={{ padding: '12px 14px', color: '#555' }}>
                                        {siparis.toplam_bedel != null
                                            ? `${Number(siparis.toplam_bedel).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺`
                                            : '—'}
                                    </td>
                                    <td style={{ padding: '12px 14px' }}>
                                        <span style={{
                                            background: kalanGunRengi(siparis.kalan_gun) + '20',
                                            color: kalanGunRengi(siparis.kalan_gun),
                                            padding: '3px 8px',
                                            borderRadius: '10px',
                                            fontSize: '12px',
                                            fontWeight: 600
                                        }}>
                                            {siparis.kalan_gun} gün
                                        </span>
                                    </td>
                                    <td style={{ padding: '12px 14px', textAlign: 'center' }}>
                                        <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', alignItems: 'center' }}>
                                            <button
                                                onClick={() => handleGeriYukle(siparis.id, siparis.siparis_no)}
                                                title="Geri Yükle"
                                                style={{
                                                    background: 'transparent',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    padding: '4px',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <img src={UndoIcon} alt="Geri Al" style={{ width: '16px', height: '16px', filter: 'invert(47%) sepia(89%) saturate(650%) hue-rotate(88deg) brightness(95%) contrast(85%)' }} />
                                            </button>
                                            <button
                                                onClick={() => handleKaliciSil(siparis.id, siparis.siparis_no)}
                                                title="Kalıcı Sil"
                                                style={{
                                                    background: 'transparent',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    padding: '4px',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <img src={DeleteIcon} alt="Sil" style={{ width: '16px', height: '16px' }} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default SilinmislerListesi;
